import React, { Component } from 'react';
import ColumnsComponent from './columns';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
import * as styles from './styles.module.css';
import type { Props } from './types';

// eslint-disable-next-line jira/react/no-class-components
export default class Fields extends Component<Props> {
	static defaultProps = {
		ColumnsComponent,
		// eslint-disable-next-line @typescript-eslint/no-empty-function
		onExperienceSuccess: () => {},
	};

	componentDidMount() {
		this.props.onExperienceSuccess && this.props.onExperienceSuccess();
	}

	render() {
		const {
			columns,
			height,
			isReadOnly = false,
			items,
			// eslint-disable-next-line @typescript-eslint/no-shadow
			ColumnsComponent,
			showOptimizations = false,
			scrollElement,
			width,
			minWidth,
			showWarning,
		} = this.props;

		return (
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
			<div className={styles.container}>
				<ColumnsComponent
					columns={columns}
					height={height}
					items={items}
					isReadOnly={isReadOnly}
					showOptimizations={showOptimizations}
					scrollElement={scrollElement}
					onDragStart={this.props.onDragStart}
					onDragEnd={this.props.onDragEnd}
					width={width}
					minWidth={minWidth}
					showWarning={showWarning}
				/>
			</div>
		);
	}
}
